import React from 'react';
import { useSelector } from 'react-redux';
import { getLoadingRedux } from 'reducers/sharedata/selector';
import loadingLogo from 'asset/inc/img/global/preload_logo.png';
import loadingImage from 'asset/inc/img/global/sprites.png';
// const loadingLogo = require('asset/inc/img/global/preload_logo.png');
// const loadingImage = require('asset/inc/img/global/sprites.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
var Style = require('./Loading_style.module.css');
export var Loading = function () {
    var loadingShow = useSelector(getLoadingRedux) > 0;
    var loadingBackgroundRef = React.createRef();
    var loadingImageRef = React.createRef();
    var cSpeed = 5;
    var cWidth = 50;
    var cHeight = 51;
    var cTotalFrames = 20;
    var cFrameWidth = 50;
    // const cImageSrc = '../../asset/inc/img/global/sprites.png';
    var cImageTimeout;
    var cIndex = 0;
    var cXpos = 0;
    var cPreloaderTimeout;
    var SECONDS_BETWEEN_FRAMES = 0;
    var stopAnimation = function () {
        // stops animation
        clearTimeout(cPreloaderTimeout);
        cPreloaderTimeout = undefined;
        if (loadingImageRef.current) {
            loadingImageRef.current.style.width = '0px';
            loadingImageRef.current.style.height = '0px';
        }
    };
    var continueAnimation = function () {
        cXpos += cFrameWidth;
        // increase the index so we know which frame of our animation we are currently on
        cIndex += 1;
        // if our cIndex is higher than our total number of frames, we're at the end and should restart
        if (cIndex >= cTotalFrames) {
            cXpos = 0;
            cIndex = 0;
        }
        if (loadingImageRef.current) {
            loadingImageRef.current.style.backgroundPosition = -cXpos + "px 0";
        }
        if (loadingShow) {
            cPreloaderTimeout = setTimeout(
            // eslint-disable-next-line @typescript-eslint/no-implied-eval
            continueAnimation, SECONDS_BETWEEN_FRAMES * 1000);
        }
        else {
            stopAnimation();
        }
    };
    var startAnimation = function () {
        if (loadingImageRef.current) {
            loadingImageRef.current.style.backgroundImage = "url(" + loadingImage + ")";
            loadingImageRef.current.style.width = cWidth + "px";
            loadingImageRef.current.style.height = cHeight + "px";
        }
        var fps = Math.round(100 / cSpeed);
        SECONDS_BETWEEN_FRAMES = 1 / fps;
        cPreloaderTimeout = setTimeout(continueAnimation, SECONDS_BETWEEN_FRAMES / 1000);
    };
    // Pre-loads the sprites image
    var imageLoader = function (s, fun) {
        clearTimeout(cImageTimeout);
        cImageTimeout = 0;
        var genImage = new Image();
        genImage.onload = function () {
            // eslint-disable-next-line @typescript-eslint/no-implied-eval
            cImageTimeout = setTimeout(fun, 0);
        };
        genImage.onerror = function () {
            if (process.env.REACT_APP_DEBUG_MODE === 'ON') {
                throw new Error('Could not load the image');
                //   return alert('Could not load the image');
            }
        };
        // genImage.onerror = new Function('alert(\'Could not load the image\')');
        genImage.src = s;
    };
    imageLoader(loadingImage, startAnimation);
    // new imageLoader(loadingImage, startAnimation);
    // if (!start) { stopAnimation(); }
    var fade = loadingShow ? Style.fadeIn : Style.fadeOut;
    return (React.createElement("div", { id: "loadingBackground", ref: loadingBackgroundRef, className: Style.loading_background + " " + fade },
        React.createElement("div", { className: Style.loading },
            loadingShow && React.createElement("img", { src: loadingLogo, alt: "" }),
            React.createElement("div", { id: "loadingImage", ref: loadingImageRef, className: Style.loading_image }))));
};
export default Loading;
